<template>
  <div id="Swirl"/>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, watch, onMounted} from 'vue'
import defaultValue from "@/utils/defaultValue";
import colorTool from "@/utils/colorTool";
const {changeToRgb, rgbToHsb} = colorTool()


const {defaultWidth, defaultHeight} = defaultValue()

const props = defineProps(['currentValue', 'effectTheme'])

const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')
let animateSpeed = ref(1) // 1, 4, 8
let high = ref(null)
let low = ref(null)
let nowTemperature = ref(null)
let backgroundColor = ref([0,0,0])
let drawPot = ref(0)
let colorLow = ref([])
let colorHigh = ref([])
let currentColorArr = reactive({arr: []})



const handleGetAnimateHSBAndSpeed = (high, low, now = 10, colorHigh, colorLow) => {

  // 高低差 range
  let lowHeightRange = Math.ceil((high - low) / 9) // 將高低差 分為 10個單位, 1單位


  let lowHeightColorRange

  let range = Math.trunc((now - low) / lowHeightRange)

  // 設定速度
  if (range <= 3) {
    animateSpeed.value = 1
    lowHeightColorRange = 1
  }
  else if (range >= 7 ) {
    animateSpeed.value = 8
    lowHeightColorRange = 10
  }
  else {
    animateSpeed.value = 4
    lowHeightColorRange = range
  }


  if (lowHeightColorRange === 1 ) currentColorArr.arr = colorLow.map(color => rgbToHsb(color))
  else if (lowHeightColorRange >= 10) currentColorArr.arr = colorHigh.map(color => rgbToHsb(color))
  else {
    const colorHighOne = rgbToHsb(colorHigh[0])
    const colorHighTwo = rgbToHsb(colorHigh[1])
    const colorHighThree = rgbToHsb(colorHigh[2])
    const colorHighFour = rgbToHsb(colorHigh[3])

    const colorLowOne = rgbToHsb(colorLow[0])
    const colorLowTwo = rgbToHsb(colorLow[1])
    const colorLowThree = rgbToHsb(colorLow[2])
    const colorLowFour = rgbToHsb(colorLow[3])

    const nowColorOne = [
      (lowHeightColorRange * colorHighOne[0] + (10 - lowHeightColorRange) * colorLowOne[0]) / 10,
      (lowHeightColorRange * colorHighOne[1] + (10 - lowHeightColorRange) * colorLowOne[1]) / 10,
      (lowHeightColorRange * colorHighOne[2] + (10 - lowHeightColorRange) * colorLowOne[2]) / 10,
    ]
    const nowColorTwo = [
      (lowHeightColorRange * colorHighTwo[0] + (10 - lowHeightColorRange) * colorLowTwo[0]) / 10,
      (lowHeightColorRange * colorHighTwo[1] + (10 - lowHeightColorRange) * colorLowTwo[1]) / 10,
      (lowHeightColorRange * colorHighTwo[2] + (10 - lowHeightColorRange) * colorLowTwo[2]) / 10,
    ]
    const nowColorThree = [
      (lowHeightColorRange * colorHighThree[0] + (10 - lowHeightColorRange) * colorLowThree[0]) / 10,
      (lowHeightColorRange * colorHighThree[1] + (10 - lowHeightColorRange) * colorLowThree[1]) / 10,
      (lowHeightColorRange * colorHighThree[2] + (10 - lowHeightColorRange) * colorLowThree[2]) / 10,
    ]
    const nowColorFour = [
      (lowHeightColorRange * colorHighFour[0] + (10 - lowHeightColorRange) * colorLowFour[0]) / 10,
      (lowHeightColorRange * colorHighFour[1] + (10 - lowHeightColorRange) * colorLowFour[1]) / 10,
      (lowHeightColorRange * colorHighFour[2] + (10 - lowHeightColorRange) * colorLowFour[2]) / 10,
    ]

    currentColorArr.arr = [
      nowColorOne,
      nowColorTwo,
      nowColorThree,
      nowColorFour,
    ]

    if (
        colorHighOne[0] === colorLowOne[0] &&
        colorHighOne[1] === colorLowOne[1] &&
        colorHighOne[2] === colorLowOne[2]
    ) {
      currentColorArr.arr[0] = colorHighOne
    }
    if (
        colorHighTwo[0] === colorLowTwo[0] &&
        colorHighTwo[1] === colorLowTwo[1] &&
        colorHighTwo[2] === colorLowTwo[2]
    ) {
      currentColorArr.arr[1] = colorHighTwo
    }
    if (
        colorHighThree[0] === colorLowThree[0] &&
        colorHighThree[1] === colorLowThree[1] &&
        colorHighThree[2] === colorLowThree[2]
    ) {
      currentColorArr.arr[2] = colorHighThree
    }
    if (
        colorHighFour[0] === colorLowFour[0] &&
        colorHighFour[1] === colorLowFour[1] &&
        colorHighFour[2] === colorLowFour[2]
    ) {
      currentColorArr.arr[3] = colorHighFour
    }
  }
}



const swirlAnimate = (sketch) => {
	let cw = defaultWidth.value
	let ch = defaultHeight.value
  let seed = sketch.random() * 1000;
  let k = 0.8515
  let l = 0.65;
  let th = 0
  let seg = 0.01;
  let r;
  let angle;
  let mySize;
  let filter;
  let overAllTexture;

  // [255,244,98], [164,99,121], [254,182,64], [255,223,124], [253,239,192]


	sketch.setup = () => {
    sketch.createCanvas(cw, ch);
    mySize = sketch.min(sketch.width, sketch.height);
    sketch.colorMode(sketch.HSB, 360, 100, 100, 255);
    sketch.background(...backgroundColor.value);
    angle = sketch.random(sketch.TAU);
    filter = new makeFilter();
  }

	sketch.draw = () => {
    drawPot.value ++
    sketch.randomSeed(seed);
    r = mySize/sketch.random(10,50);
    sketch.background(...backgroundColor.value,8); // swirl 軌跡
    let T = (1 - k) / k;
    sketch.noStroke();
    sketch.push();
    sketch.translate(sketch.width / 2, sketch.height / 2);
    // 200
    for (let i = 0; i < 200; i += sketch.random(0.75)) {
      k = sketch.random(0.75, 0.8515);
      l = sketch.random(0.45, 0.65);
      swirlDraw(i, k, l, T, currentColorArr.arr)
      if (animateSpeed.value > 1) swirlDraw(i, k, l, T, sketch.reverse(currentColorArr.arr))
      if (animateSpeed.value > 4) swirlDraw(i, k, l, T, currentColorArr.arr)
    }
    sketch.pop();
    th += seg;
    angle += sketch.TAU/sketch.random(300,600);
    sketch.image(overAllTexture, 0, 0);
    overAllTexture.remove()
	}

  function makeFilter() {
    sketch.randomSeed(seed);
    sketch.drawingContext.shadowColor = sketch.color(0, 0, 5, 10);
    overAllTexture = sketch.createGraphics(sketch.width, sketch.height);
    overAllTexture.loadPixels();
    for (let i = 0; i < sketch.width; i++) { // noprotect
      for (let j = 0; j < sketch.height; j++) {
        overAllTexture.set(
            i,
            j,
            sketch.color(208, 18, 21, sketch.noise(i / 3, j / 3, (i * j) / 100) * sketch.random(1))
        );
      }
    }
    overAllTexture.updatePixels();
  }

  function swirlDraw(i,k,l,T, colors) {
    sketch.push();
    sketch.fill(sketch.random(colors));
    sketch.rotate(sketch.random(sketch.TAU) + sketch.random(angle) * sketch.random(1, animateSpeed.value));
    sketch.rectMode(sketch.CENTER);
    sketch.rect(
        sketch.random(-i * 5, i *5) + r * ((1 - k) * sketch.cos(th) + l * k * sketch.cos(T * th)),
        sketch.random(-i * 5, i * 5) + r * ((1 - k) * sketch.sin(th) - l * k * sketch.sin(T * th)),
        sketch.random(-r / 4, r / 4),
        sketch.random(-r / 2, r / 2),
        sketch.random(1, 2)
    );
    sketch.pop();
  }
}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}

watch(drawPot, (n, o) => {
  if (n > 7200) { // 2min init
    initAnimate()
    canvasWrap.value = new p5(swirlAnimate, 'Swirl')
    drawPot.value = 0
  }
})

watch(() => effectThemeData.Sensor, (Sensor) => {
  if (Sensor) {
    initAnimate()
    canvasWrap.value =  new p5(swirlAnimate, 'Swirl')
  }
})

watchEffect(() => {
  const {
    HighValue,
    LowValue,
    IsDynamicMode,
    Speed: rotateSpeed,
    BackgroundColor,
    Colors,
    HighColors,
    LowColors
  } = effectThemeData

  // 背景色, 背景圖 需 重置動畫
  let bgHsbColor = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? rgbToHsb(BackgroundColor) : [0,0,0]


  if (
      backgroundColor.value[0] !== bgHsbColor[0] ||
      backgroundColor.value[1] !== bgHsbColor[1] ||
      backgroundColor.value[2] !== bgHsbColor[2]
  ) {
    backgroundColor.value = bgHsbColor
    // create p5
    if (canvasWrap.value !== 'stop') {
      initAnimate()
      canvasWrap.value = new p5(swirlAnimate, 'Swirl')
    }
  }

  nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''

  if (IsDynamicMode.toString() === 'false') {
    currentColorArr.arr = Colors.map(color => rgbToHsb(color))
    if (rotateSpeed && rotateSpeed > 0) animateSpeed.value = rotateSpeed
  } else if (IsDynamicMode.toString() === 'true') {
    high.value = HighValue
    low.value = LowValue
    colorHigh.value = HighColors
    colorLow.value = LowColors
    handleGetAnimateHSBAndSpeed(high.value, low.value, nowTemperature.value, colorHigh.value, colorLow.value)
  }

})

onMounted(() => {
  // create p5
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(swirlAnimate, 'Swirl')
})


onUnmounted(() => {
  drawPot.value = 0
  nowTemperature.value = null
  backgroundColor.value = [0,0,0]
  high.value = null
  low.value = null
  animateSpeed.value = 1
  currentColorArr.arr = []
  high.value = null
  low.value = null
  colorHigh.value = []
  colorLow.value = []
  initAnimate()
})

</script>
